// A tiny wrapper around fetch(), borrowed from
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper
import {API_URL} from "./Constants";

export enum Methods {
    Get = "GET",
    Post = "POST",
    Put = "PUT",
    Delete = "DELETE"
}

export const apiClient = async (method: Methods, path: string, body?: any, formData?: boolean) => {
    return baseRequest(method, path, true, body, formData);
};

apiClient.get = (path: string) => {
    return apiClient(Methods.Get, path);
};

apiClient.post = (path: string, body?: any) =>  {
    return apiClient(Methods.Post, path, body);
};

apiClient.upload = (path: string, body: any) =>  {
    return apiClient(Methods.Post, path, body, true);
};

apiClient.put = (path: string, body: any) =>  {
    return apiClient(Methods.Put, path, body);
};

apiClient.delete = (path: string) =>  {
    return apiClient(Methods.Delete, path);
};


export const baseRequest = async (method: Methods, path: string, isFirstAttempt: boolean, body?: any, formData?: boolean): Promise<any> => {

    const endpoint = API_URL +  path;

    let contentTypeHeader = {};
    if (formData) {

        //const boundary = '--------------------------' + Math.floor(Math.random() * 1e10).toString(16);

        //contentTypeHeader = { 'Content-Type': `multipart/form-data; boundary=${boundary}` };

        //console.log('boundary', boundary);
        console.log('boundary payload', Object.fromEntries(body.entries()));
        console.log('boundary header', contentTypeHeader);

    } else {
        contentTypeHeader = { 'Content-Type': 'application/json' };
    }
    const cookieHeader = { "Cookie": ""};

    let jwt = null;
    let authorizationHeader = null;
    if (path !== "/auth/login") {
        jwt = localStorage.getItem('token');
        authorizationHeader = { "Authorization": "Bearer " + jwt};
    }

    const config: any = {
        method: method,
        headers: {
            ...contentTypeHeader,
            ...cookieHeader
        },
    };

    if (body) {
        config.body = formData ? body : JSON.stringify(body);
    }
    if (jwt) {
        config.headers = {
            ...config.headers,
            ...authorizationHeader
        }
    }

    //console.log("🔵 baseRequest REQUEST:", path, config, endpoint);

    let data;
    try {
        const response = await window.fetch(endpoint, config);

        let responseStatus = response.status;

        if ( (responseStatus >= 200 && responseStatus <= 299) && response.ok) {
            let data = null;
            if (!response.headers.get("content-type")) { // No reponse content
                data = await response.json();
            } else if (response.headers.get("content-type") === "application/json;charset=UTF-8") { // json payload
                data = await response.json();
            } else {
                data = await response.json();
            }

            //console.log("\x1b[32m%s\x1b[0m", "🟢 baseRequest SUCCESS:", path, JSON.stringify(response), JSON.stringify(data));

            return {
                status: responseStatus,
                data,
                headers: response.headers,
                url: response.url,
            };

        } else if (responseStatus === 401 && path !== "/auth/login") {

            console.log("\x1b[31m%s\x1b[0m", "🔴 baseRequest ERROR 1:", path, "Error 401");

            if (isFirstAttempt) {
                return Promise.resolve(refreshJwt(method, path, body, formData));
            } else { // jwt was successfully updated but baseRequest still fails with 401
                return Promise.reject("baseRequest Error 401");
            }
        }

        const responseData = await response.json();
        console.log('EndRideError client', responseData);
        console.log("\x1b[31m%s\x1b[0m", "🔴 baseRequest ERROR 2:", path, responseData);
        throw new Error(JSON.stringify(responseData));
        Promise.reject(responseData);

    } catch (err) {
        console.log("\x1b[31m%s\x1b[0m", "🔴 baseRequest ERROR 3:", path, err.message, endpoint, {
            ...config.headers,
            ...authorizationHeader
        });
        return Promise.reject(err.message);
    }
};


export const refreshJwt = async (method: Methods, path: string, body?: any, formData?: boolean) => {

    const endpoint = API_URL + "auth/refresh";

    const refreshToken = localStorage.getItem('token');

    const config: any = {
        method: Methods.Post,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${refreshToken}`
        },
    };

    config.body = JSON.stringify({
        refreshToken: refreshToken
    });

    //console.log("🔵 refreshJwt REQUEST:", path, JSON.stringify(config));

    try {
        const response = await window.fetch(endpoint, config);

        let responseStatus = response.status;
        // responseStatus = 401; // temp

        if (responseStatus === 200 && response.ok) {
            const data = await response.json();
            const {access_token} = data;
            localStorage.setItem('token',access_token);

            //console.log("\x1b[32m%s\x1b[0m", "🟢 refreshJwt SUCCESS:", path, JSON.stringify(data), access_token);

            return Promise.resolve(baseRequest(method, path, false, body, formData));

        } else {

            console.log("\x1b[31m%s\x1b[0m", "🔴 refreshJwt ERROR 1:", path, response);

            logoutAndNavigateToLogin();
            return Promise.reject("refreshJwt ERROR 1");
        }


    } catch (err) {
        logoutAndNavigateToLogin();
        console.log("\x1b[31m%s\x1b[0m", "🔴 refreshJwt ERROR 2:", path, err.message);
        return Promise.reject("refreshJwt ERROR 2");
    }
};

const logoutAndNavigateToLogin = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
};